export function formatarDataParaInput(data: string | null): string {
  if (!data) return "";
  const [dia, mes, ano] = data.split("/");
  if (!dia || !mes || !ano) return "";
  return `${dia.padStart(2, "0")}/${mes.padStart(2, "0")}/${ano}`;
}
